<template>
    <div class="app-container">
        <div
        class="community-container"
        :class="isCollapse?'collapse':''">
            <pang-title :text="$router.lang.get('社 群')" eng="Community"/>
            <div class="tab-container">
                <pang-tab
                :tabs="tabs" v-model:current="currentTab"/>
                <pang-butt @click="newPost" :text="$router.lang.get('發文')" icon="fa fa-edit" :style="{padding: '0', width: (isCollapse?screenState.screenWidth * 0.04 + 51:87) + 'px', margin: 'auto'}" :loading="loading"/>
                <pang-search
                ref="search"
                v-if="!isCollapse"
                :searchTypes="searchTypes"
                v-model:searchType="searchTypeTemp"
                v-model:keyword="keywordTemp"
                @search="gosearch"
                :loading="loading"/>
            </div>
            <pang-article :totalPages="totalPages" :articles="articles" v-model:currentPage="currentPage" @change="getCommunitys"/>
        </div>
    </div>
</template>

<script>

import { useScreenState } from '../../store';
import request from '../../api/request'
import enums from '../../utils/enums'
import { PangTitle, PangTab, PangSearch, PangArticle, PangButt } from '../../components'
import message from '../../utils/message'

const pathTabMapping = [
    '/community/gamer',
    '/community/strategy',
    '/community/picture',
]

export default {
    name: 'Community',
    components: {
        PangTitle,
        PangTab,
        PangSearch,
        PangArticle,
        PangButt,
    },
    data () {
        return {
            loading: false,
            screenState: useScreenState(),
            tabs: [
                this.$router.lang.get('玩家討論區'),
                this.$router.lang.get('攻略討論區'),
                this.$router.lang.get('圖片分享區'),
            ],
            searchTypes: [
                this.$router.lang.get('主题'),
                this.$router.lang.get('全文'),
            ],
            currentTab: 0,
            searchType: this.$router.lang.get('主题'),
            searchTypeTemp: this.$router.lang.get('主题'),
            keyword: '',
            keywordTemp: '',
            currentPage: 1,
            totalPages: 1,
            articles: [],
        };
    },
    methods: {
        constructParams () {
            let params = {page: this.currentPage}
            params['section'] = this.currentTab + 1
            if (this.keyword) {
                if (this.searchType == this.$router.lang.get('全文') )
                    params['search'] = this.keyword
                else
                    params['article__title__contains'] = this.keyword
            }
            return params
        },
        gosearch (data) {
            this.keyword = data.keyword
            this.searchType = data.searchType
            this.getCommunitys()
        },
        newPost () {
            console.log(pathTabMapping[this.currentTab] + '/new')
            this.$router.push(pathTabMapping[this.currentTab] + '/new')
        },
        getCommunitys () {
            this.keywordTemp = this.keyword
            this.searchTypeTemp = this.searchType
            let params = this.constructParams()
            this.loading = true;
            let _this = this
            request.get('/communities' , params, _this).then(function (res) {
                if (res.status == 200) {
                    _this.totalPages = res.data.paging.total_pages
                    _this.currentPage = res.data.paging.page
                    _this.articles = res.data.results.map(function (x) {
                        let aType = _this.$router.lang.get('其他')
                        if (x.community_type)
                            aType = enums.COMMUNITY_TYPE[x.community_type]
                        else if (x.strategy_type)
                            aType = enums.STRATEGY_TYPE[x.strategy_type]
                        return {
                            title: x.article.title,
                            type: aType,
                            create_at: x.create_at,
                            abstract: x.article.abstract,
                            href: pathTabMapping[x.section-1] + '/' + x.id,
                        }
                    })
                }
                else {
                    message.resMessage(res, _this)
                }
                _this.loading = false;
            })
        },
    },
    computed: {
        isCollapse() {
        return this.screenState.screenWidth < 900;
        },
    },
    mounted () {
        this.currentTab = pathTabMapping.indexOf(this.$route.path)
        let params = {}
        if (this.currentTab > 0)
            params['community_type'] = this.currentTab
        this.getCommunitys(params)
    },
    watch: {
        currentTab(val) {
            this.$router.replace(pathTabMapping[val])
        }
    },
}
</script>

<style>
.community-container .pang-tab > div {
    min-width: 110px;
    margin-right: 1vw;
}

.collapse .pang-tab > div {
    width: 20.27vw;
}
</style>

<style scoped>

.community-container {
    max-width: 985px;
    width: 90vw;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 100px;
}

.tab-container {
    display: flex;
}

.post-butt {
    width: 87px;
    height: 38px;
    line-height: 38px;
    background: linear-gradient(132deg, #C6A86C 0%, #E0CDA5 100%);
    border-radius: 19px;
    margin: auto;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
}

.post-butt img {
    width: 16px;
    height: 16px;
    margin-bottom: -3px;
}

</style>
